<template>
  <b-form-row>
    <b-col lg="3">
      <form-select
        id="innegov"
        :ep="govsEndpoint"
        label="المحافظة"
        :reduce="(x) => x.id"
        :getOptionLabel="(x) => x.name_ar"
        v-model="gov"
        @input="
          area = null;
          setDefaultCenter();
          area = null;
          $refs.governorateAreas.refreshOptions(areasEp);
        "
      />

      <form-select
        label="المنطقة/ الحي"
        id="areas"
        ref="governorateAreas"
        :getOptionLabel="(x) => x.name_ar"
        :ep.sync="areasEp"
        v-model="area"
        placeholder="ابدأ بالكتابة للبحث"
      />

      <form-input v-if="!noAddress" label="العنوان" v-model="address" />
      <slot />

      <b-form-group label="الإحداثيات" label-for="lnglat">
        <b-form-row id="lnglat">
          <b-col>
            <b-form-group label-size="xs" label="خط العرض" label-for="lat">
              <b-form-input
                size="sm"
                id="lat"
                readonly
                :value="markerPos.lat"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="lng" label="خط الطول">
              <b-form-input
                size="sm"
                id="lng"
                readonly
                :value="markerPos.lng"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-form-group>
    </b-col>
    <b-col lg="9">
      <l-map
        ref="map"
        v-if="map"
        :key="center[0]"
        :zoom.sync="zoom"
        :center="center"
      >
        <l-marker
          style="width: 100%; height: 100%"
          @update:latLng="updateMarker"
          :lat-lng="marker"
          draggable
          v-if="marker.length === 2"
        ></l-marker>
        <l-tile-layer :url="url" />
      </l-map>
    </b-col>
    <b-col cols="12"><hr /></b-col>
    <b-col cols="12" class="justify-content-end d-flex">
      <b-button
        :disabled="markerPos.lng === 0 || markerPos.lat === 0"
        variant="success"
        @click="onSubmit"
      >
        تأكيد
      </b-button>
    </b-col>
  </b-form-row>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import {
  BForm,
  BFormGroup,
  BRow,
  BFormInput,
  BFormRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import "leaflet/dist/leaflet.css";
import FormSelect from "../form-select/index.vue";
import FormInput from "../form-input/index.vue";

import FormAutocomplete from "../form-autocomplete/index.vue";
import { Icon } from "leaflet";
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
/* eslint-disable global-require */
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    BForm,
    BFormGroup,
    BRow,
    BFormInput,
    BFormRow,
    BCol,
    BButton,
    FormSelect,
    FormAutocomplete,
    FormInput,
  },
  props: {
    govsEndpoint: {
      type: String,
      default: () => "v2/map/govs",
    },
    areasEndpoint: {
      type: String,
      default: () => "v2/map/governorate-areas/",
    },
    noAddress: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      areasKey: 0,
      address: "",
      map: false,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 6,
      center: [34.8021, 37.9968],
      defaultCenter: [34.8021, 37.9968],
      marker: [],
      markerPos: {
        lng: 0,
        lat: 0,
      },
      area: null,
      gov: null,
    };
  },
  watch: {
    area: {
      deep: true,
      handler(val) {
        if (val) this.setCenter(val);
        else this.setDefaultCenter();
      },
    },
    gov(val) {
      if (!val) this.$store.commit("areas/setOptions", []);
    },
    areasKey(val) {
      if (this.gov) this.$refs.governorateAreas.refreshOptions();
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.map = true;
      }, 100);
    });
  },
  computed: {
    areasEp() {
      return this.gov ? this.areasEndpoint + this.gov : "v";
    },
  },

  methods: {
    init(obj) {
      this.gov = obj.gov;
      this.area = obj.area;
      this.address = obj.address;
      this.$nextTick(() => {
        this.$refs.governorateAreas.refreshOptions(this.areasEp);
      });
    },
    setDefaultCenter() {
      this.zoom = 6;
      this.$set(this.center, 0, this.defaultCenter[0]);
      this.$set(this.center, 1, this.defaultCenter[1]);
      this.markerPos = {
        lng: 0,
        lat: 0,
      };
      this.marker = [];
    },
    setCenter(area) {
      this.zoom = 13;
      this.$set(this.center, 0, area.latitude);
      this.$set(this.center, 1, area.longitude);
      this.$set(this.marker, 0, area.latitude);
      this.$set(this.marker, 1, area.longitude);
      this.markerPos = {
        lng: area.longitude,
        lat: area.latitude,
      };
    },
    updateMarker(x) {
      this.markerPos = x;
    },
    onSubmit() {
      this.$emit("markerUpdated", {
        pos: this.markerPos,
        govId: this.gov,
        area: this.area,
        address: this.address,
      });
      this.$emit("closeModal");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/map-leaflet.scss";

.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
</style>
